import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext({ site: null, reload: () => {} });

function setHead(selector, tag, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const reload = useCallback(() => api.get("/public/site").then((r) => setSite(r.data)).catch(() => setSite({})), []);
  useEffect(() => {
    reload();
  }, [reload]);
  useEffect(() => {
    if (site?.favicon_url) {
      setHead('link[rel="icon"]', "link", { rel: "icon", href: site.favicon_url });
    }
  }, [site]);
  return <SiteCtx.Provider value={{ site, reload }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);

export function useSeo({ title, description, image } = {}) {
  const { site } = useSite();
  useEffect(() => {
    if (!site) {
      return;
    }
    const t = title || site.seo_title;
    const d = description || site.meta_description || "";
    const img0 = image || site.og_image_url;
    const img = img0 && img0.startsWith("/") ? `${window.location.origin}${img0}` : img0;
    if (t) document.title = t;
    setHead('meta[name="description"]', "meta", { name: "description", content: d });
    setHead('meta[property="og:title"]', "meta", { property: "og:title", content: t || "" });
    setHead('meta[property="og:description"]', "meta", { property: "og:description", content: d });
    if (img) setHead('meta[property="og:image"]', "meta", { property: "og:image", content: img });
  }, [site, title, description, image]);
}

export const FEATURE_LABELS = {
  card_payments: "Online card payments for fees",
  sponsors: "Sponsors wall & enquiries",
  embeds: "Forms & embeds",
  themes: "Light themes & custom colours",
};
